export default
{
  Standard: {
    'message[Thickness]': {
      '1/2': {
        'message[Shape]': [
          'Square',
          'Bevel',
          'Radius',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
          'fabrifill',
        ],
      },
      '3/8': {
        'message[Shape]': [
          'Square',
          'Bevel',
          'Radius',
        ],
        'message[Infill]': [
          'fabrifill',
        ],
      },
      '3/4': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'fiberglass',
          'terracoreTackable',
        ],
      },
      '1': {
        'message[Shape]': [
          'Square',
          'Bevel',
          'Radius',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
        ],
      },
      '1 1/4': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
        ],
      },
      '2': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
        ],
      },
    },
  },
  Green: {
    'message[Thickness]': {
      '1/2': {
        'message[Shape]': [
          'Square',
          'Bevel',
          'Radius',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
          'fabrifill',
        ],
      },
      '1': {
        'message[Shape]': [
          'Square',
          'Bevel',
          'Radius',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
          'terracoreTackable',
          'micore',
        ],
      },
    },
  },
  Ceiling: {
    'message[Thickness]': {
      '1': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
        ],
      },
      '1 3/8 GEO': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
        ],
      },
      '1 3/8 Std.': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
        ],
      },
      '2': {
        'message[Shape]': [
          'Square',
        ],
        'message[Infill]': [
          'terracore',
          'fiberglass',
        ],
      },
    },
  },
  Autem: {
    'message[Thickness]': {
      '1': {},
      '2': {},
    },
  },
};
